module.exports = __webpack_public_path__ + "static/media/chatboss-1.15d8c7a6.svg";